import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getClientsFilter = createAsyncThunk(
  "clientsFilter/getClientsFilter",
  async (
    { advisorId, accountType, accountId, investmentId, timeFrame, search },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();

      if (advisorId) params.append("advisorId", advisorId);
      if (accountType) params.append("productId", accountType);
      if (accountId) params.append("accountId", accountId);
      if (investmentId) params.append("investmentId", investmentId);
      if (timeFrame) params.append("timeFrame", timeFrame);
      if (search) params.append("search", search);

      const query = `/api/clientsFilter?${params.toString()}`;

      const response = await getMethod(query);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Failed to fetch clients filter");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);


const clientsFilterSlice = createSlice({
  name: "clientsFilter",
  initialState: {
    loading: false,
    fltrclients: [],
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientsFilter.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getClientsFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.fltrclients = action.payload?.data || [];
        state.success = true;
      })
      .addCase(getClientsFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export default clientsFilterSlice.reducer;
